import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    Cookies.set('cookie-consent', 'accepted', { expires: 365 });
    setShowBanner(false);
  };

  const declineCookies = () => {
    Cookies.set('cookie-consent', 'declined', { expires: 365 });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-content">
        <p className="cookie-text">
          We use cookies to improve your experience on our site. By continuing to browse, you agree to our use of cookies. 
          <a href="/privacy-policy" className="cookie-link">Learn more</a>
        </p>
        <div className="cookie-buttons">
          <button onClick={acceptCookies} className="cookie-btn accept" data-testid="cookie-accept">
            Accept
          </button>
          <button onClick={declineCookies} className="cookie-btn decline" data-testid="cookie-decline">
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;